import React from 'react'
import PropTypes from 'prop-types'
import isUserAddonsValid from '../../utils/helpers/isUserAddonsValid'

const IsUserAddonsAuthorized = ({ acceptedAddons, children }) => {
  if (!children) return null
  const isAccepted = isUserAddonsValid(acceptedAddons)

  return isAccepted ? <div>{children}</div> : null
}

IsUserAddonsAuthorized.propTypes = {
  acceptedAddons: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default IsUserAddonsAuthorized
